export function isAiAnalysisAvailable(availability, type) {
  return Array.isArray(availability) && availability.includes(type);
}
